const ApiModals = {
    'body':'',
    'start':function(){
        let self = this;
        self.init();

        self.setModals();
    },
    'setModals': function(){
        let self = this;

        let Modal = self.body.find('.modals');
        let modals = self.body.find('[modal-trigger]');
        modals.each(function(){
            let modal = $(this);
            modal.on('click', function(){
               let thisClick = $(this);
               let modalName = thisClick.attr('modal-trigger');
                // console.log('modal click');
                ApiAjax.callModal(modalName);
            });


        });
    },
    'init':function(){
        let self = this;
        self.body = $('body');
    }
}

$(document).ready(function(){
    ApiModals.start();
});
